import React, { useState } from "react";
import axios from "axios";
import { server } from "../server";
export default function () {
  // State to manage form data
  const [projectType, setProjectType] = useState("Network"); // Default option: 'Network'
  const [entityName, setEntityName] = useState("");
  const token = JSON.parse(localStorage.getItem("bvmToken"));

  // Handle project type change
  const handleProjectTypeChange = (e) => {
    setProjectType(e.target.value);
  };

  // Handle entity name change
  const handleEntityNameChange = (e) => {
    setEntityName(e.target.value);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare data to send in POST request
    const requestData = {
      projectType: projectType,
      entityName: entityName,
    };

    try {
      // Send POST request with axios
      const response = await axios.post(`${server}/api/project`, requestData);
      console.log("Response:", response.data);
      // You can show a success message or handle response as needed
    } catch (error) {
      console.error("Error submitting data:", error);
      // Handle error (e.g., display a message to the user)
    }
  };

  return (
    <div>
      <h2>Project Form</h2>
      <form onSubmit={handleSubmit}>
        {/* Project Type Radio Buttons */}
        <div>
          <label>
            <input
              type="radio"
              value="Network"
              checked={projectType === "Network"}
              onChange={handleProjectTypeChange}
            />
            Network
          </label>
          <label>
            <input
              type="radio"
              value="Software"
              checked={projectType === "Software"}
              onChange={handleProjectTypeChange}
            />
            Software
          </label>
        </div>

        {/* Entity Name Input */}
        <div>
          <label>
            Entity Name:
            <input
              type="text"
              value={entityName}
              onChange={handleEntityNameChange}
              placeholder="Enter entity name"
            />
          </label>
        </div>

        {/* Submit Button */}
        <button type="submit">Submit</button>
      </form>
    </div>
  );
}
